import React from 'react'

function PurchaseGRNEntry() {
  return (
    <div>Purchase / GRN Entry</div>
  )
}

export default PurchaseGRNEntry